import React from "react";
import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import App from "./App";
// import "@fontsource/montserrat";

const container = document.getElementById("root");

// ReactDOM.render(<App />, document.getElementById('root'));

const root = createRoot(container);
root.render(<App />);
